import { departmentResources } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IDepartmentResources } from "../../models/master/departmentResources";

export default new (class DepartmentResourceService {
  public getDepartmentResource = async (id: number): Promise<IApiResponse<IDepartmentResources>> => {
    try {
      let endPoint = urlBinder(departmentResources.GET_DEPARTMENT_RESOURCE, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDepartmentResources>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDepartmentResources>;
      } else {
        throw error;
      }
    }
  };

  public getDepartmentResources = async (
    pageBlockId?: number, noOfItems?: number, configUserType?: number
  ): Promise<IApiResponse<Array<IDepartmentResources>>> => {
    try {
      let endPoint = urlBinder(departmentResources.GET_ALL_DEPARTMENT_RESOURCES, [pageBlockId,noOfItems, configUserType]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IDepartmentResources>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IDepartmentResources>>;
      } else {
        throw error;
      }
    }
  };

  public createDepartmentResource = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = departmentResources.CREATE_DEPARTMENT_RESOURCE;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateDepartmentResource = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(departmentResources.UPDATE_DEPARTMENT_RESOURCE, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateDepartmentResourcePriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = departmentResources.UPDATE_DEPARTMENT_RESOURCE_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteDepartmentResource = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(departmentResources.DELETE_DEPARTMENT_RESOURCE, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
